module.exports = __webpack_public_path__ + "img/violet-2.005d11fc.png";